import { rgb } from 'pdf-lib';
import { DocumentElement } from './document-element.model';

export const RevokeConfiguration: DocumentElement = {
  generationDate: {
    x: 93,
    y: 591.45,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold-italic',
    height: 0,
    width: 0,
    adjustBy: 'height',
  },
  name: {
    x: 150,
    y: 485.3,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
  registerNumber: {
    x: 150,
    y: 456.5,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
  permissionDate: {
    x: 150,
    y: 428.4,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
  validFor: {
    x: 150,
    y: 400,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
  protocol: {
    x: 150,
    y: 371,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
  protocolDate: {
    x: 150,
    y: 342.3,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
};
